import React from "react";
import VlogList from "../VlogList/VlogList";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const VlogListLeetCode = () => {
  const title = "פתרונות LeetCode";
  const description = `ברוכים הבאים למאגר הידע שלי על LeetCode! כאן מחכה לכם אוסף ייחודי של וולוגים שמעמיקים בעולם פתרון השאלות הפופולריות ביותר מ-LeetCode. בכל וולוג נתמקד בשאלה, נבין את הדרישות והאילוצים שלה. נסקור גישות שונות לפתרון, ולבסוף נלמד על סיבוכיות זמן וזיכרון, שיעזרו לכם לחדד את החשיבה האלגוריתמית שלכם. הוולוגים נועדו לעזור לכם לשפר את כישורי התכנות, להתמודד עם בעיות אלגוריתמיות בצורה יעילה, ולהגיע מוכנים לראיונות עבודה. בין אם אתם בתחילת הדרך או מתכוננים לשלבים מתקדמים בקריירה, תמצאו כאן ערך רב.`;

  const vlogs = [
    {
      topic: "Array",
      vlogs: [
        { id: "LeetCodeJson/Question1", name: "Two sum" },
        {
          id: "LeetCodeJson/Question121",
          name: "Best time to buy and sell stock",
        },
        { id: "LeetCodeJson/Question217", name: "Contains duplicate" },
        {
          id: "LeetCodeJson/Question238",
          name: "Product of Array Except Self",
        },
        {
          id: "LeetCodeJson/Question53",
          name: "Maximum Subarray",
        },
        {
          id: "LeetCodeJson/Question152",
          name: "Maximum Product Subarray",
        },
        {
          id: "LeetCodeJson/Question153",
          name: "Find Minimum in Rotated Sorted Array",
        },
        {
          id: "LeetCodeJson/Question33",
          name: "Search in Rotated Sorted Array",
        },
        {
          id: "LeetCodeJson/Question15",
          name: "3Sum",
        },
        {
          id: "LeetCodeJson/Question11",
          name: "Container With Most Water",
        },
      ],
    },
    {
      topic: "String",
      vlogs: [
        { id: "LeetCodeJson/Question20", name: "Valid parentheses" },
        {
          id: "LeetCodeJson/Question424",
          name: "Longest Repeating Character Replacement",
        },
        {
          id: "LeetCodeJson/Question76",
          name: "Minimum Window Substring",
        },
        {
          id: "LeetCodeJson/Question242",
          name: "Valid Anagram",
        },
        {
          id: "LeetCodeJson/Question49",
          name: "Group Anagrams",
        },
        {
          id: "LeetCodeJson/Question3",
          name: "Longest Substring Without Repeating Characters",
        },
        {
          id: "LeetCodeJson/Question125",
          name: "Valid Palindrome",
        },
        {
          id: "LeetCodeJson/Question5",
          name: "Longest Palindromic Substring",
        },
        {
          id: "LeetCodeJson/Question271",
          name: "Encode and Decode Strings",
        },
      ],
    },
    {
      topic: "Linked List",
      vlogs: [
        { id: "LeetCodeJson/Question206", name: "Reverse linked list" },
        { id: "LeetCodeJson/Question141", name: "Linked List Cycle" },
        { id: "LeetCodeJson/Question21", name: "Merge Two Sorted Lists" },
        { id: "LeetCodeJson/Question23", name: "Merge k Sorted Lists" },
        {
          id: "LeetCodeJson/Question19",
          name: "Remove Nth Node From End of List",
        },
        { id: "LeetCodeJson/Question143", name: "Reorder List" },
      ],
    },
    {
      topic: "Binary",
      vlogs: [
        { id: "LeetCodeJson/Question371", name: "Sum of two integers" },
        {
          id: "LeetCodeJson/Question191",
          name: "Number of 1 bits",
        },
        {
          id: "LeetCodeJson/Question338",
          name: "Counting Bits",
        },
        {
          id: "LeetCodeJson/Question268",
          name: "Missing Number",
        },
        { id: "LeetCodeJson/Question190", name: "Reverse Bits" },
      ],
    },
    {
      topic: "Dynamic Programming",
      vlogs: [
        { id: "LeetCodeJson/Question70", name: "Climbing Stairs" },
        { id: "LeetCodeJson/Question322", name: "Coin Change" },
      ],
    },
    {
      topic: "Tree",
      vlogs: [
        {
          id: "LeetCodeJson/Question104",
          name: "Maximum Depth of Binary Tree",
        },
        {
          id: "LeetCodeJson/Question102",
          name: "Binary Tree Level Order Traversal",
        },
        { id: "LeetCodeJson/Question100", name: "Same Tree" },
        {
          id: "LeetCodeJson/Question124",
          name: "Binary Tree Maximum Path Sum",
        },
      ],
    },
    {
      topic: "Matrix",
      vlogs: [
        { id: "LeetCodeJson/Question73", name: "Set Matrix Zeroes" },
        { id: "LeetCodeJson/Question54", name: "Spiral Matrix" },
        { id: "LeetCodeJson/Question48", name: "Rotate Image" },
        { id: "LeetCodeJson/Question79", name: "Word Search" },
      ],
    },
  ];

  return (
    <>
      <VlogList title={title} description={description} vlogs={vlogs} />
    </>
  );
};

export default VlogListLeetCode;
